import { render, staticRenderFns } from "./PopUpSetting.vue?vue&type=template&id=3cf72e0c&scoped=true"
import script from "./PopUpSetting.vue?vue&type=script&lang=js"
export * from "./PopUpSetting.vue?vue&type=script&lang=js"
import style0 from "./PopUpSetting.vue?vue&type=style&index=0&id=3cf72e0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf72e0c",
  null
  
)

export default component.exports